const root = document.documentElement;
const menuToggles = document.querySelectorAll('[data-toggle-menu]');
const bp = window.matchMedia("(max-width: 47.5rem)");
let isDesktop = !bp.matches;
let isMobile = bp.matches;

/*
 * Hero height
 */

const heroZone = document.getElementById("heroZone");
const heroZoneMobile= document.getElementById("heroZone");
const heroImage = document.getElementById("heroImage");
const heroImageMobile= document.getElementById("heroImage");
const heroTitle = document.getElementById("heroTitle");
const heroTitleMobile= document.getElementById("heroTitle");

const getHeight = async (el, elMobile, name) => {
	let mql = window.matchMedia('(max-width: 47.5rem)');
	if (elMobile && el && mql) {
		const height = mql.matches ? elMobile.offsetHeight : el.offsetHeight;
		document.documentElement.style.setProperty(`--${name}`, `${ height }px`);
		return height;
	}
}

// const setHeroZoneHeight = () => {
// 	let mql = window.matchMedia('(max-width: 47.5rem)');
// 	if ( heroZone && heroZoneMobile ) {
// 		getHeight(heroImage, heroImageMobile, 'heroImageHeight').then( data => {
// 			getHeight(heroTitle, heroTitleMobile, 'heroTitleHeight').then( data => {
// 				document.documentElement.style.setProperty('--heroZoneHeight', `${mql.matches ?  heroZoneMobile.offsetHeight : heroZone.offsetHeight }px`);
// 			})
// 		})

// 	}
// }


// demo(2).then(function(value) {
// 	console.log(value);
// }).catch((err) => {
// 	console.log(err);
// })

/*
 * Header height
 */

const menuMenuEl = document.getElementById("menuToggle");
const header = document.getElementById("globalHeader");
const announcementBar = document.getElementById("shopify-section-shopcanvas-announcement-bar");
const headerMobile= document.getElementById("mobileNavHeader");
const cartcount= document.getElementById("cartcount");
const setHeaderHeight = () => {
	let mql = window.matchMedia('(max-width: 47.5rem)');
	if ( header && headerMobile ) {
		document.documentElement.style.setProperty('--headerHeight', `${mql.matches ?  headerMobile.offsetHeight : header.offsetHeight }px`);
		if (announcementBar) {
			document.documentElement.style.setProperty('--announcementBarHeight', `${ announcementBar.offsetHeight }px`);
			document.documentElement.style.setProperty('--headerHeightFull', `${mql.matches ? (headerMobile.offsetHeight + announcementBar.offsetHeight) : (header.offsetHeight + announcementBar.offsetHeight) }px`);
		}
	}

	if (cartcount) document.documentElement.style.setProperty('--cartcountPost', cartcount.getBoundingClientRect().left);

}


const toggleMenu = (e) => {
	if (e) e.preventDefault();

	root.toggleAttribute('data-menu-opened');

	menuToggles.forEach( menuToggle => {
		menuToggle.toggleAttribute('data-menu-opened');
	});
}

menuToggles.forEach( menuToggle => {
	menuToggle.addEventListener('click', e => {
		toggleMenu();
		setVH();
		e.preventDefault();
	})
});


const pxToRems = (px, padding = 0) => (Number((px.toString().replace('px','')) / 16) + padding).toString() + 'rem';

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

const debouncer = (func, time) => {
	// console.log('debounce')
	time = time || 100;
	let timer;

	return (event) => {
		if(timer) clearTimeout(timer);
		timer = setTimeout(func, time, event);
	};
}

const resetSizes = () => {
	windowHeight = window.innerHeight;
	containerDistance = container.getBoundingClientRect().top;
	containerHeight = container.offsetHeight;
	canvasHeight = canvas.offsetHeight;
	setHeaderHeight();
};

let setVH = () => {
	vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	setHeaderHeight();
};


/*
	INITS
 */

window.addEventListener("resize", debouncer(setVH, 30));
window.onresize = debouncer(setVH, 30);
setVH();
setHeaderHeight();


